import React from "react";
import AnyChart from 'anychart-react'
import anychart from "anychart";
const { Component } = React;

export default class AgeChart extends Component {

  constructor(props) {
    super(props);
    this.containerId = props.containerId;
    this.chart = anychart.bar();
    this.series = null;
    this.chart.animation(true);

    this.chart.padding([10, 20, 20, 20]);

    this.chart.yScale().stackMode('value');

    this.chart
      .yAxis()
      .labels()
      .format(function () {
        return Math.abs(this.value).toLocaleString();
      });

    this.chart.xAxis(0).overlapMode('allow-overlap');

    this.chart.title()
      .enabled(true)
      .text("Distribución por edad")
      .fontSize(14);

    this.chart.interactivity().hoverMode('by-x');

    this.chart
      .tooltip()
      .title(false)
      .separator(false)
      .displayMode('union')
      .positionMode('point')
      .fontSize(12)
      .offsetX(5)
      .offsetY(0)
      .format(function () {
        return (
          this.seriesName + ": " + Math.abs(this.value).toLocaleString()
        );
      });

      this.chart.legend().enabled(false);

  }

  generateChart(data) {

    var ageCaption = data.captions["age"]
    var ageLabels = Object.keys(ageCaption.labels);
    
    var prevData = {
      0: Array(ageLabels.length-1).fill(0),
      1: Array(ageLabels.length-1).fill(0)
    };

    Object.keys(data.counts).forEach((zoneId) => {
      data.counts[zoneId].segments.forEach((segment) => {
        prevData[segment.descriptors.gender][segment.descriptors.age] += segment.value
      });
    });

    var chartData = {0: [], 1: []}

    var max = 0;

    for (var age = ageLabels.length-1; age >= 0 ; age--) {
      chartData[0].push([ageCaption.labels[age], prevData[0][age]]);
      chartData[1].push([ageCaption.labels[age], -prevData[1][age]]);

      if (max < prevData[0][age])
        max = prevData[0][age];
      if (max < prevData[1][age])
        max = prevData[1][age];
    }

    Math.max(max,1);

    if (this.series == null) {
      var dataSet0 = anychart.data.set(chartData[0])
      var dataSet1 = anychart.data.set(chartData[1])

      var series0 = this.chart.bar(dataSet0);
      series0.name('Hombres').color('blue');
      series0.tooltip().position('right').anchor('left-center');

      var series1 = this.chart.bar(dataSet1);
      series1.name('Mujeres').color('hotpink');
      series1.tooltip().position('left').anchor('right-center');

      this.series = [series0,series1]
    } else {
      this.series[0].data(chartData[0])
      this.series[1].data(chartData[1])
    }

    this.chart.yScale().minimum(-max).maximum(max);
    
    this.chart.container(this.containerId);
    
    this.chart.draw();

    return this.chart;
  }

  render() {
    return (
      <AnyChart 
        id={this.containerId}
        intance={this.props.data != null ? this.generateChart(this.props.data) : null}/>
    );
  }

}
